import { render, staticRenderFns } from "./travel-insurance-form.html?vue&type=template&id=1ec988f6&scoped=true&"
import script from "./travel-insurance-form.js?vue&type=script&lang=js&"
export * from "./travel-insurance-form.js?vue&type=script&lang=js&"
import style0 from "./travel-insurance-form.scss?vue&type=style&index=0&id=1ec988f6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec988f6",
  null
  
)

export default component.exports